export default __webpack_public_path__ + "static/media/vault.b6423a16.png";